import Splide from "@splidejs/splide";
import Staff from "./Staff";

class Slider {
  init() {
    this.employees = document.querySelectorAll("[js-splide-employees]");
    this.departments = document.querySelector("[js-splide-staff-tabs]");
    this.roomsNav = document.querySelector("[js-splide-rooms-nav]");
    this.roomsBanner = document.querySelector("[js-splide-rooms-banner]");
    this.offersBanner = document.querySelector("[js-splide-offers-banner]");
    this.roomsDesktopBanner = document.querySelector("[js-splide-desktop-rooms-banner]");
    this.roomsBannerMobile = document.querySelector("[js-splide-rooms-banner-mobile]");
    this.buttonsOpenLightbox = document.querySelectorAll("[js-open-lightbox]");
    this.buttonsCloseLightbox = document.querySelector("[js-close-lightbox]");
    this.staff();
    this.tabs();
    this.rooms();
    this.banner();
    this.bannerDesktop();
    this.bannerMobile();
    this.bannerOffers();
  }

  staff() {
    if (this.employees.length) {
      this.employees.forEach((slider) => {
        return new Splide(slider, {
          type: "loop",
          perPage: 1,
          perMove: 1,
          pagination: true,
          arrows: false,
          speed: 500,
          width: "100%",
        }).mount();
      });
    }
  }

  tabs() {
    if (this.departments) {
      const staff = new Staff();
      const splide = new Splide(this.departments, {
        type: "loop",
        perPage: 2,
        perMove: 1,
        isNavigation: true,
        focus: "center",
        pagination: false,
        arrows: true,
        speed: 500,
        width: "100vw",
        updateOnMove: true,
      }).mount();

      splide.on("moved", () => {
        const activeTab = document.querySelector(".staff__tabs .is-active.is-visible a");
        const id = activeTab.getAttribute("href");

        staff.staffToggle(id);
      });
    }
  }

  rooms() {
    if (this.roomsNav) {
      const splide = new Splide(this.roomsNav, {
        type: "loop",
        perPage: 2,
        perMove: 1,
        isNavigation: true,
        focus: "center",
        pagination: false,
        arrows: true,
        speed: 500,
        width: "100vw",
        updateOnMove: true,
      });

      splide.on("mounted", () => {
        const activeSlide = document.querySelector(".splide__slide > .is-active");
        const id = activeSlide.closest("li").getAttribute("aria-label");
        const toActivateIndex = id.charAt(id.length - 1) - 1;
        splide.go(toActivateIndex);
      });

      splide.mount();
    }
  }

  banner() {
    if (this.roomsBanner) {
      const splide = new Splide(this.roomsBanner, {
        type: "fade",
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: true,
        speed: 500,
        width: "50%",
      });

      splide.mount();

      window.addEventListener("click", (e) => {
        this.buttonsOpenLightbox.forEach((button) => {
          if (e.target == button) {
            const id = parseFloat(button.dataset.index);
            splide.go(id);

            setTimeout(() => {
              this.roomsBanner.parentElement.classList.add("is-visible");
              document.body.style.overflow = "hidden";
            }, 100);
          }
        });

        if (e.target == this.buttonsCloseLightbox || e.target == this.roomsBanner.parentElement) {
          this.roomsBanner.parentElement.classList.remove("is-visible");
          document.body.style.overflow = "scroll";
        }
      });
    }
  }

  bannerDesktop() {
    if (this.roomsDesktopBanner) {
      const splide = new Splide(this.roomsDesktopBanner, {
        type: "fade",
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: true,
        speed: 500,
        width: "100%",
      });

      splide.mount();

      window.addEventListener("click", (e) => {
        this.buttonsOpenLightbox.forEach((button) => {
          if (e.target == button) {
            const id = parseFloat(button.dataset.index);
            splide.go(id);

            setTimeout(() => {
              this.roomsBanner.parentElement.classList.add("is-visible");
              document.body.style.overflow = "hidden";
            }, 100);
          }
        });

        if (e.target == this.buttonsCloseLightbox || e.target == this.roomsBanner.parentElement) {
          this.roomsBanner.parentElement.classList.remove("is-visible");
          document.body.style.overflow = "scroll";
        }
      });
    }
  }

  bannerMobile() {
    if (this.roomsBannerMobile) {
      return new Splide(this.roomsBannerMobile, {
        type: "loop",
        perMove: 1,
        pagination: true,
        arrows: false,
        speed: 500,
        width: "100%",
        breakpoints: {
          992: {
            perPage: 1.5,
          },
          768: {
            perPage: 1,
          },
        },
      }).mount();
    }
  }

  bannerOffers() {
    if (this.offersBanner) {
      const splide = new Splide(this.offersBanner, {
        type    : 'loop',
        perPage : 1,
        autoplay: true,
        pagination: true,
        arrows: true,
        width: "100%",
      });

      splide.mount();

      window.addEventListener("click", (e) => {
        this.buttonsOpenLightbox.forEach((button) => {
          if (e.target == button) {
            const id = parseFloat(button.dataset.index);
            splide.go(id);

            setTimeout(() => {
              this.roomsBanner.parentElement.classList.add("is-visible");
              document.body.style.overflow = "hidden";
            }, 100);
          }
        });

        if (e.target == this.buttonsCloseLightbox || e.target == this.roomsBanner.parentElement) {
          this.roomsBanner.parentElement.classList.remove("is-visible");
          document.body.style.overflow = "scroll";
        }
      });
    }
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./scripts/Slider.js